<template>
  <div style="padding: 20px 0px 0px 20px;">

    <el-form style="display: flex;flex-wrap: wrap;">

      <el-form-item label="老师:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择老师" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="部门:" style="display: flex;width: 33%;">
        <el-select style="width: 100%" v-model="resumeNumber3" popper-class="tree-select-popper"  ref="treeSelect1">
            <el-option hidden :value="resumeNumber3"> </el-option>
            <el-tree
                :data="dataTrees"
                :props="defaultPropss"
                node-key="deptId"
                ref="treeSelect1"
                :highlight-current="true"
                :check-on-click-node="true"
                @check="handleTreeCheck">
            </el-tree>
        </el-select>
      </el-form-item>


      <el-form-item label="兑换礼品:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择兑换礼品" v-model="input33" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList9" :key="item.id" :value="item.id" :label="item.integralName"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="所需积分:" style="display: flex;width: 33%;">
        <el-input v-model="input333" placeholder="请输入所需积分"></el-input>
      </el-form-item> -->



      <el-form-item label="提交日期:" style="display: flex;width: 60%;">
        <el-date-picker 
            v-model="input2" 
            value-format="yyyy-MM-dd" 
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>



<!--  <el-form-item label="项目名称:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item> -->


      <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
        <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus"  @click="searchAddBtns">添加</el-button> -->
        <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button> -->
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"   @click="searchBtns">搜索</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"   @click="clearBtns">清空</el-button>
      </div>

    </el-form>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700">
      <el-table-column prop="teacherName" label="老师" show-overflow-tooltip></el-table-column>
      <el-table-column prop="deptName" label="部门" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralName" label="兑换礼品" show-overflow-tooltip></el-table-column>
      <el-table-column prop="applyForIntegral" label="所需积分" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="提交日期" show-overflow-tooltip></el-table-column>

      <!-- <el-table-column prop="classFee" label="添加时间" show-overflow-tooltip></el-table-column> -->

      <el-table-column prop="auditStatus" label="审批状态" show-overflow-tooltip>
        <template v-slot="scope">
          <div style="display: flex;justify-content: space-around;color:rgb(231 169 28);;"  v-if="scope.row.auditStatus === 0">未审批</div>
          <div style="display: flex;justify-content: space-around;color:rgb(222 18 169);" v-if="scope.row.auditStatus === 1">审批中</div>
          <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);" v-if="scope.row.auditStatus === 2">审批成功</div>
          <div style="display: flex;justify-content: space-around;color:rgb(231 28 28);" v-if="scope.row.auditStatus === 3">审批驳回</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template v-slot="scope">
          <div style="display: flex;justify-content: space-around;">
            <el-button type="text" style="color:rgb(227 151 73);" @click="handleClickView('详情', scope.row)">查看</el-button>
            <el-button type="text" :style="{ color: scope.row.auditStatus === 2 || scope.row.auditStatus === 3 ? 'rgb(184 193 198)' : '#00aaff' }"  :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 3" @click="handleClickView('编辑', scope.row)">编辑</el-button>
            <el-button type="text" :style="{ color: scope.row.auditStatus === 2 || scope.row.auditStatus === 3 ? 'rgb(184 193 198)' : 'rgb(224 5 5)' }"  :disabled="scope.row.auditStatus === 2 || scope.row.auditStatus === 3" @click="handleClickView('审批', scope.row)">审批</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>

    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" :title="Titlecenter" :visible="addShow" :before-close="closeEditDialog" width="80%">

      <el-form style=""   :disabled="ishowoTypeDisabled">

        <el-form-item label="老师:" style="width: 100%;">
          <el-select placeholder="请选择老师" v-model="input11" style="width: 100%" clearable filterable  :disabled="isTrue">
            <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="部门:" style="width: 100%;">
          <el-select style="width: 100%" v-model="resumeNumber33" popper-class="tree-select-popper"  ref="treeSelect2" :disabled="isTrue">
              <el-option hidden :value="resumeNumber33"> </el-option>
              <el-tree
                  :data="dataTrees"
                  :props="defaultPropss"
                  node-key="deptId"
                  ref="treeSelect2"
                  :highlight-current="true"
                  :check-on-click-node="true"
                  @check="handleTreeChecks">
              </el-tree>
          </el-select>
        </el-form-item>


        <el-form-item label="兑换礼品:" style="width: 100%;">
          <el-select placeholder="请选择兑换礼品" v-model="input3333" style="width: 100%" clearable filterable :disabled="isTrue">
            <el-option v-for="item in optionList9" :key="item.id" :value="item.id" :label="item.integralName"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所需积分:" style="width: 100%;">
          <el-input v-model="input333333" placeholder="请输入所需积分"></el-input>
        </el-form-item>



        <el-form-item label="提交时间:" style="width: 100%;">
          <el-date-picker v-model="input2222" type="date" style="width: 100%;" value-format="yyyy-MM-dd" placeholder="请选择日期" clearable :disabled="isTrue"></el-date-picker>
        </el-form-item>

      </el-form>


    <div style="display: flex; margin-bottom: 20px; justify-content: end;">
      <el-button  type="primary" size="small" class="btns"  v-if="!ishowoTypeDisabled"  @click="handleClickViewBtn('保存')">保存</el-button>
      <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('取消')">取消</el-button>
    </div>


    </el-dialog>








    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="审批详情" :visible.sync="showDomg1" :before-close="showDomg1closeEditDialog" width="50%">

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 100%;padding-top: 10px;">提交人:   {{ itmeCopy.teacherName }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 100%;padding-top: 10px;">提交说明:  {{ inputValuetextarea1 }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.createTime">
        <div style="width: 100%;padding-top: 10px;">提交时间:  {{ itmeCopy.createTime }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.firstApprove">
        <div style="width: 100%;padding-top: 10px;">一级审批人:   {{ itmeCopy.firstApproveName }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.firstAuditOpinion">
        <div style="width: 100%;padding-top: 10px;">一级审批意见:   {{ itmeCopy.firstAuditOpinion }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.firstAuditDate">
        <div style="width: 100%;padding-top: 10px;">一级审批时间:   {{ itmeCopy.firstAuditDate }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.secondApprove">
        <div style="width: 100%;padding-top: 10px;">二级审批人:   {{ itmeCopy.secondApproveName }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.secondAuditOpinion">
        <div style="width: 100%;padding-top: 10px;">二级审批意见:   {{ itmeCopy.secondAuditOpinion }}</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;" v-if="itmeCopy.secondAuditDate">
        <div style="width: 100%;padding-top: 10px;">二级审批时间:   {{ itmeCopy.secondAuditDate }}</div>
      </div>

    </el-dialog>




    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="审批" :visible.sync="showDomg" :before-close="showDomgcloseEditDialog" width="50%">


      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">提交说明:</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;pointer-events: none;" >
        <el-input style="width: 100%;" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" maxlength="300" show-word-limit  v-model="inputValuetextarea1"></el-input>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <div style="width: 80px;padding-top: 10px;">审批意见:</div>
      </div>

      <div style="display: flex; margin-bottom: 20px;">
        <el-input style="width: 100%;" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" maxlength="300" show-word-limit  v-model="inputValuetextarea"></el-input>
      </div>

      <div style="display: flex; margin-bottom: 20px; justify-content: center;">
        <el-button  type="primary" size="small" class="btnss"  @click="handleClickViewBtn1('驳回')">驳回</el-button>
        <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn1('通过')">通过</el-button>
      </div>

    </el-dialog>

  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getTeachers } from "@/api/fiveClassApi"


export default {
  components: {

  },
  data() {
    return {

      ishowoTypeDisabled: false,
      isTrue: false,


      value1: '',
      value2: [],
      value3: [],

      integralCount: 0,


      input33:'',
      input333:'',



      inputValue1: '',
      inputValue2: 0 ,
      inputValue3: '',

      Titlecenter: '添加积分项目',
      optionList4: [{ id: 0, name: '无效' }, { id: 1, name: '有效' }],

      optionList1: [],
      optionList2: [],
      optionList3: [{ id: 0, name: '待审批' }, { id: 1, name: '驳回' }, { id: 2, name: '已完成' }],

      input1: '',
      input2: [],
      input3: '',

      dataList: [],

      pageNum: 1,
      pageSize: 10,
      total: 0,


      pageNum1: 1,
      pageSize1: 10,
      total1: 0,

      CourseCancellationComponentsType: '',
      CourseCancellationComponentsID: '',
      CourseCancellationComponentsShow: false,

      CourseCancellationomponentsTypeDistinguish: '课消审批',

      dataList1:[],


      addShow: false,

      inputID:'',

      optionList5:[],
      teacherIditme:null,


      resumeNumber3Id:'',
      resumeNumber3:'',

      dataTrees:[],
      defaultPropss:{ children: 'children', label: 'deptName' },


      input11:'',
      resumeNumber33:'',
      resumeNumber33Id:'',
      input3333:'',
      input333333:'',
      input2222:'',


      itmeCopy:{},
      showDomg1:false,
      inputValuetextarea1:'',


      createTime:'',
      firstAuditopinion:'',
      firstAuditDate:'',
      showDomg:false,

      inputValuetextarea:'',


      optionList9:[],
    }
  },

  mounted() {
    getTeachers().then(res => { this.optionList1 = res.data })
    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.optionList2 = res.data.data })
    axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})


    axios.post(`${apiBaseUrl}/integralProject/queryIntegralList`, { integralType:'2', integralName:'', }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      if (res.data.code === 200) {
        let data = res.data.data
        this.optionList9 = data
      } else {
        this.optionList9 = []
        this.$message.error(res.data.message)
      }
    }).catch((err) => {
      this.$message.error(err)
    })


    this.getApiList()
    this.handleintegralProject()
  },


  methods: {

    handleClickViewBtn1(type){
      
        if(type === '驳回'){
        this.$confirm('确定要驳回此条信息吗?, 是否继续?', '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',  type: 'warning' }).then(() => {

            let data = {}

            if(this.itmeCopy.auditStatus === 0 || this.itmeCopy.auditStatus === '0'){
              data = {  id: this.itmeCopy.id,  firstAuditOpinion: this.inputValuetextarea, firstAuditStatus: 2,  }
            }

            if(this.itmeCopy.auditStatus === 1 || this.itmeCopy.auditStatus === '1'){
              data = {  id: this.itmeCopy.id,  secondAuditOpinion: this.inputValuetextarea, secondAuditStatus: 2,  }
            }

            axios.post(`${apiBaseUrl}/integralAudit/audit`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
              if (res.data.code === 200) {
                this.inputValuetextarea = ''
                this.$message({ message:res.data.message, type: "success" })
                this.getApiList()
                this.showDomg = false
              } else {
                this.$message.error(res.data.message)
              }
            }).catch((err) => {
              this.$message.error(err)
            })

        })
      }


      if(type === '通过'){
        this.$confirm('确定要通过此条信息吗?, 是否继续?', '提示', {  confirmButtonText: '确定', cancelButtonText: '取消',  type: 'warning' }).then(() => {

          let data = {}

            if(this.itmeCopy.auditStatus === 0 || this.itmeCopy.auditStatus === '0'){
              data = {  id: this.itmeCopy.id,  firstAuditOpinion: this.inputValuetextarea, firstAuditStatus: 1,  }
            }

            if(this.itmeCopy.auditStatus === 1 || this.itmeCopy.auditStatus === '1'){
              data = {  id: this.itmeCopy.id,  secondAuditOpinion: this.inputValuetextarea, secondAuditStatus: 1,  }
            }

            axios.post(`${apiBaseUrl}/integralAudit/audit`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
              if (res.data.code === 200) {
                this.inputValuetextarea = ''
                this.$message({ message:res.data.message, type: "success" })
                this.getApiList()
                this.showDomg = false
              } else {
                this.$message.error(res.data.message)
              }
            }).catch((err) => {
              this.$message.error(err)
            })

        })
      }
    },

    handleTreeCheck(e){
      this.resumeNumber3 = e.deptName
      this.resumeNumber3Id = e.deptId
      this.$refs.treeSelect1.visible = false
    },


    handleTreeChecks(e){
      this.resumeNumber33 = e.deptName
      this.resumeNumber33Id = e.deptId
      this.$refs.treeSelect2.visible = false
    },

    handleintegralProject(){
      axios.post(`${apiBaseUrl}/integralProject/findList`, { integralName:'' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.optionList5 = data
        } else {
          this.optionList5 = []
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },




    handleClickViewBtn(type){
      if(type === '取消'){
        this.addShow = false
        this.inputValuetextarea = ''
      }

      if(type === '保存'){  
            let data = {
              id: this.itmeCopy.id,
              applyForIntegral: this.input333333,
            }
            axios.post(`${apiBaseUrl}/integralAudit/editExchangeIntegral`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {

              if (res.data.code === 200) {
                  this.$message({ message:res.data.message, type: "success" })
                  this.addShow = false
                  this.inputValuetextarea = ''
                  this.getApiList()
              } else {
                this.$message.error(res.data.message)
                this.addShow = false
              }
            }).catch((err) => {
              this.$message.error(err)
            })

      }
    },

    searchAddBtns() {
      this.Titlecenter = '添加积分项目'
      this.addShow = true
      this.ishowoTypeDisabled = false
    },

    closeEditDialog() {
      this.Titlecenter = ''
      this.inputValue1 = ''
      this.inputValue2 = 0
      this.inputValue3 = ''
      this.inputID = ''

      this.value1 = ''
      this.value2 = []
      this.value3 = []

      this.input11 = ''
      this.resumeNumber33 = ''
      this.input3333 = ''
      this.input333333 = ''
      this.input2222 =''


      this.addShow = false
    },

    CourseCancellationhandleEmit(e) {
      this.CourseCancellationComponentsShow = e
    },

    searchBtns() {
      this.pageNum = 1
      this.pageSize = 10
      this.getApiList()
    },

    searchBtns1() {
      this.getApiList1()
    },

    clearBtns1() {
      this.value1 = ''
      this.value2 = []
      this.value3 = []
      this.getApiList1()
    },


    clearBtns() {
      this.input1 = ''
      this.input2 = []
      this.input3 = ''
      this.input4 = ''
      this.input33 = ''
      this.input333 = ''
      this.resumeNumber3 = ''

      this.pageNum = 1
      this.pageSize = 10

      this.getApiList()
    },

    exportBtns(){
      let data = {
        // pageNum: this.pageNum1,
        // pageSize: this.pageSize1,
        teacherId: this.input1,
        commitStartDate: this.input2 ,
        // auditStartDate: (this.value3 && this.value3.length > 0) ? this.value3[0] + ' 00:00:00' : null,
        // auditEndDate: (this.value3 && this.value3.length > 0) ? this.value3[1] + ' 00:00:00' : null,
        // integralId: this.value1,
      }
      axios.post(`${apiBaseUrl}/integralAudit/exportTeacherIntegral`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
           if(response.status == 200){
               const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
               const downloadLink = document.createElement("a")
               downloadLink.href = URL.createObjectURL(blob)
               downloadLink.download = "积分详情.xlsx"
               downloadLink.click()
               this.$message({ message:'导出成功', type: "success" });
           } else{
              this.$message.error('导出失败')
           }
       }).catch((err) => {
          this.$message.error(err)
      })
    },


    getApiList1() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        teacherId: this.input1,
        deptId: this.resumeNumber3Id,
        integralId: this.input33,
        commitStartDate: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        commitEndDate: (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 23:59:59' : null,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findExchangePage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList1 = data.records.records
          this.total1 = data.records.total ? data.records.total : 0
          this.integralCount = data.integralCount

          if(data.records && data.records.records.length < 0){
            this.dataList1 = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {

          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    getApiList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        teacherId: this.input1,
        deptId: this.resumeNumber3Id,
        integralId: this.input33,
        commitStartDate: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        commitEndDate: (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 23:59:59' : null,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findExchangePage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList = data.records
          this.total = data.total ? data.total : 0
          if(data.records && data.records.length < 0){
            this.dataList = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleSizeChange(e) {
      this.pageSize = e
      this.getApiList()
    },

    handleSizeChange1(e) {
      this.pageSize1 = e
      this.getApiList1()
    },


    handleCurrentChange(e) {
      this.pageNum = e
      this.getApiList()
    },


    handleCurrentChange1(e) {
      this.pageNum1= e
      this.getApiList1()
    },

    showDomgcloseEditDialog() {
      this.showDomg = false
    },

    handleClickView(type, itme) {

      this.itmeCopy = itme

      if (type === '编辑') {
        console.log(itme)
        this.ishowoTypeDisabled = false
        this.isTrue = true
        this.Titlecenter = '编辑积分项目'

        this.inputValue1 = itme.inputValue1
        this.inputValue2 = itme.inputValue2
        this.inputValue3 = itme.inputValue3
        this.inputID = itme.id

        this.input11 = itme.teacherId
        this.resumeNumber33 = itme.deptName
        this.input3333 = itme.integralId
        this.input333333 = itme.applyForIntegral
        this.input2222 = itme.createTime

        this.addShow = true

      }

      if (type === '详情') {
         this.inputValuetextarea1 = itme.auditExplain
         this.showDomg1 = true
      } 

      if (type === '删除') {
         console.log(itme)
        // 提示二次删除确认
        this.$confirm('确定删除该条信息吗?, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 发送删除请求
          axios.post(`${apiBaseUrl}/`, { id: itme.id }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if (res.data.code === 200) {
              this.$message({ message: res.data.message, type: "success" });
              this.getApiList()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
          })
        })
      }



      if (type === '审批') {
         this.inputValuetextarea1 = itme.auditExplain
         this.createTime = itme.createTime
         this.firstAuditopinion = itme.firstAuditopinion
         this.firstAuditDate = itme.firstAuditDate
         this.showDomg = true
      }


    },

    showDomg1closeEditDialog() {
      this.showDomg1 = false
      this.inputValuetextarea1 = ''
      this.itmeCopy = {}
    },

  }

}
</script>


<style scoped lang="less">
.no-click {
  pointer-events: none;
}


.btnss{
  background-color: #d80b2a;
  border-color: #d80b2a;
}
</style>



// WEBPACK FOOTER //
// src/IntegralExchang/IntegralExchang.vue